module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "hero-body main-background"
  }, [_h('div', {
    staticClass: "container has-text-centered"
  }, [_h('div', {
    staticClass: "columns is-mobile"
  }, [_m(0), " ", _h('div', {
    staticClass: "column is-two-thirds-mobile is-half-tablet is-one-quarter-desktop"
  }, [_h('figure', {
    staticClass: "image",
    attrs: {
      "id": "main_image"
    }
  }, [(displayImage) ? _h('img', {
    attrs: {
      "src": displayImage
    }
  }) : _h('img', {
    attrs: {
      "src": "/static/img/9.svg"
    }
  }), " "])]), " ", _m(1)]), " ", _h('p', {
    staticClass: "instruction",
    domProps: {
      "innerHTML": _s(instructionMessage)
    }
  }), " ", _h('a', {
    staticClass: "button is-light is-medium file-upload"
  }, [_h('span', [_s(uploadButtonMessage)]), " ", _h('input', {
    attrs: {
      "type": "file",
      "id": "file_picker",
      "accept": "image/*"
    },
    on: {
      "change": uploadHandler
    }
  })]), " ", (mainImage) ? _h('router-link', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "to": "/small-images"
    }
  }, ["Go to Step 2"]) : _e()])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "column"
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "column"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe8a8bf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 127
// module chunks = 2